<template lang="html">
  <div class="table">
    <div class="no-data" v-if="noData">{{noDataText}}</div>

    <div v-else class="table-container">
      <div class="inner-scroll">
        <table>
          <thead>
            <td
              v-for="(heading, keyIndex) in columnHeadings"
              :class="[{'tdbutton': isButton(keyIndex)}]"
              >
              {{heading}}
            </td>
          </thead>

          <tbody>
            <tr @click="onRowClick(row)" v-for="(row, rowIndex) in rows" :key="rowIndex">
              <td
                v-for="(key, keyIndex) in columnKeys"
                :class="[{'tdbutton': isButton(keyIndex)}]"
                :key="key">
                {{row[key]}}
                <slot :name="'td-' + rowIndex + '-' + key"></slot>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination v-if="!noPagination" :pageInfo="pageInfo" @getData="getData"/>
    </div>
  </div>
</template>

<script>
  import Pagination from './Pagination'

  /**
   * Map Column `headings` by `key` to be used in table
   *
   * @param {array} headings - headings prop
   * @param {string} key - Key to use from heading objects
   * @returns {array} - Mapped headings
   */
  function mapHeadings(headings, key) {
    return headings.map((h) => {
      if(typeof h === 'string') {
        return h
      } else {
        return h[key]
      }
    })
  }

  export default {
    name: 'Table',

    components: {Pagination},

    props: {
      name: String,
      results: Function,
      pages: Number,
      headings: Array,
      noPagination: Boolean,
      filter: {
        default: '',
        type: String,

      }
    },

    data() {
      return {
        rows: [],
        pageInfo: {
          page_number: 1,
          page_size: 10
        }
      }
    },

    computed: {
      noData() {
        return !this.rows.length
      },

      noDataText() {
        return (this.name) ? `No ${this.name} to show.` : 'No data to show.'
      },

      columnHeadings() {
        return mapHeadings(this.headings, 'heading')
      },

      columnKeys() {
        return mapHeadings(this.headings, 'key')
      }
    },

    methods: {
      getData(p) {
        this.results(p, this.filter ? this.filter : false).then(({data, page}) => {
          this.rows = data
          this.pageInfo = page
        })
      },

      onRowClick(row) {
        this.$emit('rowClick', row)
      },

      isButton(keyIndex) {
        return this.headings[keyIndex].button ? true : false
      }
    },

    mounted() {
      this.getData(this.pageInfo)
    },

    watch: {
      filter() {
        this.getData(this.pageInfo)
      }
    }
  }
</script>

<style lang="sass">
  @import '../../styles/base/variables.sass'
  @import '../../styles/base/themes'
  @import '../../styles/helpers/mixins'

  .table
    @include themify($themes)
      background: themed('table-background')
      border-radius: themed('table-radius')
      box-shadow: themed('table-shadow')
      color: themed('table-txt-color')
     
    overflow: hidden

    .inner-scroll
      width: 100%
      overflow-x: auto
      -webkit-overflow-scrolling: touch

  .no-data
    padding: 20px
    text-align: center
    font-size: 14px

  table
    padding: 10px
    width: 100%
    border-collapse: collapse

    td
      &.tdbutton
        width: 20px

      .status
        display: block

      div
        span
          display: flex
          justify-content: center

  thead
    @include themify($themes)
      background: themed('thead-background')
      color: themed('thead-color')

    font-weight: bold
    text-transform: uppercase
  
    td
      white-space: nowrap
      line-height: 1

      &.tdbutton
        text-align: center

      @include themify($themes)
        padding: themed('thead-td-padding')
        font-weight: themed('thead-td-weight')
        font-size: themed('thead-font-size')
        
      &:first-child 
        @include themify($themes)
          border-radius: themed('td-radius-left')

      &:last-child
        @include themify($themes)
          border-radius: themed('td-radius-right')

  tr
    @include themify($themes)
      border-bottom: themed('tr-border-bottom')
  
    &:first-child
      @include themify($themes)
        border-top: themed('tr-border-top')
    td
      @include themify($themes)
        padding: themed('td-padding')
      
      font-size: 12px


</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Table.vue